import { Injectable } from "@angular/core";
import { SecureStorageService } from "../secure-storage/secure-storage.service";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  constructor(private storageService: SecureStorageService) {}

  setLocalStorage(key: string, value) {
    this.storageService.secureLocalStorage.setItem(key, value);
  }
  getLocalStorage(key: string) {
    return this.storageService.secureLocalStorage.getItem(key);
  }
  clearLocalStorage() {
    return this.storageService.secureLocalStorage.clear();
  }

  setSessionStorage(key: string, value) {
    this.storageService.secureSessionStorage.setItem(key, value);
  }
  getSessionStorage(key: string) {
    return this.storageService.secureSessionStorage.getItem(key);
  }
  clearSessionStorage() {
    return this.storageService.secureSessionStorage.clear();
  }
}
